import { Button } from 'anf-core-react';
import React, {
  useRef, createRef,
} from 'react';

export default function ZoomImageThumbnails({
  orderedImages,
  onThumbnailClick,
  activeImage,
  tmntData,
}) {
  const altMainImage = (type) => tmntData.mainImageAltText.value.replace('{0}', type);

  const imagesLength = orderedImages.length;
  const imageRefs = useRef([]);
  if (imageRefs.current.length !== imagesLength) {
    imageRefs.current = Array(imagesLength).fill().map((_, i) => imageRefs.current[i] || createRef());
  }
  const setFocus = () => {
    const activeIndex = orderedImages.findIndex((image) => image.imageId === activeImage.imageId);
    imageRefs.current[activeIndex].current.children[0].focus();
  };
  return (
    <div className="scope-1892 zoom-thumbnails">
      {orderedImages.map(({ imageId, type, thumbnailSrc }, index) => (
        <div ref={imageRefs.current[index]} key={imageId}>
          <Button
            classList="zoom-thumbnail-button"
            variant="borderless"
            onClick={() => { onThumbnailClick(index); }}
          >
            <img
              className="zoom-thumbnail-image"
              data-testid="zoom-thumbnail-image"
              alt={altMainImage(type)}
              src={thumbnailSrc}
              onLoad={setFocus}
              data-selected={activeImage.imageId === imageId}
            />
          </Button>
        </div>
      ))}
    </div>

  );
}
